import angular from 'angular';
import signOffComponent from './sign-off.component';

export default angular.module('components.app.product.signOff', [])
  .component('signOff', signOffComponent)
  .value('EventEmitter', payload => ({ $event: payload }))
  .name;



// WEBPACK FOOTER //
// ./components/app/product/sign-off/sign-off.module.js